import { render, staticRenderFns } from "./role-history.vue?vue&type=template&id=8db0892e&scoped=true&"
import script from "./role-history.vue?vue&type=script&lang=js&"
export * from "./role-history.vue?vue&type=script&lang=js&"
import style0 from "./role-history.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./role-history.vue?vue&type=style&index=1&id=8db0892e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db0892e",
  null
  
)

export default component.exports